import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/power-tools`;

const powerToolsService = {
  search: (facilityId, q) => apiClient.get(`${base(facilityId)}/search`, { params: { q } }),

  bulkRateUpdate: (facilityId, payload) =>
    apiClient.post(`${base(facilityId)}/bulk/rate-update`, payload),
  bulkStatusUpdate: (facilityId, payload) =>
    apiClient.post(`${base(facilityId)}/bulk/status-update`, payload),
  bulkMessageSend: (facilityId, payload) =>
    apiClient.post(`${base(facilityId)}/bulk/message-send`, payload),

  listSavedReports: (facilityId) => apiClient.get(`${base(facilityId)}/reports`),
  createSavedReport: (facilityId, payload) =>
    apiClient.post(`${base(facilityId)}/reports`, payload),
  deleteSavedReport: (facilityId, reportId) =>
    apiClient.delete(`${base(facilityId)}/reports/${reportId}`),
};

export default powerToolsService;
